
<script> 
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreatePersonel',
  props:[
    "list"
  ],
  data() {
    return {
      options: [],
      form: {},
      submitted: false,
    };
  },
  validations: {
    form: {
      name: { required },
      username: { required },
      password: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if(this.form.id)
          this.update();
        else
          this.create();

          this.$emit('loadItems');
      }
      this.submitted = false;
    },
    create(){
      this.$http.post('/technic-service/personal/store', this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/technic-service/personal/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/stations/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script>

<template>
  <b-modal id="modal-scoped" size="sm"  title="Teknik Personel Ekle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
         <div class="col-12">
            <div class="mb-3">
              <label for="name">İsim Soyisim</label>
              <input
                id="name"
                v-model="form.name"
                type="text"
                class="form-control"
                placeholder="İsim Soyisim"
                :class="{
                  'is-invalid': submitted && $v.form.name.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.name.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
         <div class="col-12">
            <div class="mb-3">
              <label for="username">Kullanıcı Adı</label>
              <input
                id="username"
                v-model="form.username"
                type="text"
                class="form-control"
                placeholder="Kullanıcı Adı"
                :class="{
                  'is-invalid': submitted && $v.form.username.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.username.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="password">Kullanıcı Şifre</label>
              <input
                id="password"
                v-model="form.password"
                type="text"
                class="form-control"
                placeholder="Kullanıcı Şifre"
                :class="{
                  'is-invalid': submitted && $v.form.password.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.password.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>